/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable comma-dangle */
import React, {useState, useEffect, useRef}		from 'react';
import SvgColor									from 'react-svg-color';

import * as ft_divPosition						from '../../functions/divPosition';

import {IconProps}								from './interface';

import './Icon.css';


function Icon(props: IconProps): JSX.Element {
	props = {type: 'primary', ...props};

	const [hover, set_hover] = useState(false);
	const [popupPosition, set_popupPosition] = useState({left: 0});
	const [popupBeforePosition, set_popupBeforePosition] = useState({left: 0});

	const iconEl = useRef<HTMLDivElement>(null);
	const popupEl = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const main = document.getElementById('main');

		if (hover && popupEl.current && iconEl.current && main) {
			const iconPosition = ft_divPosition.getWindowPosition(iconEl.current);
			const mainPosition = ft_divPosition.getWindowPosition(main);
			let current: (HTMLElement | null) = iconEl.current;
			let isModal = false;
			let left = -10;

			while (current && !isModal) {
				current = current.parentElement;

				if (current?.className.includes('modalRight'))
					isModal = true;
			}

			const sizeUse = isModal ? window.innerWidth : main.offsetWidth + mainPosition.left;

			if (iconPosition.left + popupEl.current.offsetWidth > sizeUse - 10)
				left = sizeUse - 10 - popupEl.current.offsetWidth - iconPosition.left;

			set_popupPosition({left});
			set_popupBeforePosition({left: -left});
		}
	}, [hover, popupEl, iconEl]);

	const style: React.CSSProperties = props.style || {};
	const styleImg: React.CSSProperties = {};
	let iconColor: (string | string[] | undefined);

	if (props.size) {
		style.maxHeight = props.size;
		style.maxWidth = props.size;
		style.minHeight = props.size;
		style.minWidth = props.size;
	}
	if (props.borderSize !== undefined)
		style.borderWidth = props.borderSize;

	if (props.iconSize) {
		styleImg.width = props.iconSize;
		styleImg.height = props.iconSize;
	}
	if (props.iconWidth)
		styleImg.width = props.iconWidth;
	if (props.iconHeight)
		styleImg.height = props.iconHeight;

	if (props.iconColor) {
		if (typeof props.iconColor === 'string')
			iconColor = [props.iconColor];
		else
			iconColor = props.iconColor;
	}

	function renderIcon(iconOnly = false) {
		return (
			<div
				ref={iconEl}
				style={props.popup ? {position: 'relative'} : {}}
				onMouseEnter={props.popup ? () => set_hover(true) : undefined}
				onMouseLeave={props.popup ? () => set_hover(false) : undefined}
				className={`iconContainer ${props.flex && 'flex flex-center'} ${props.className}`}
			>
				{iconColor ?
					<SvgColor
						style={{
							cursor:  (iconOnly && props.onClick) && 'pointer',
							display: iconOnly && 'flex',
							...(!props.iconBorder && {...style}),
							...styleImg
						}}
						svg={props.icon}
						colors={iconColor}
						onClick={props.onClick}
						className={props.classNameIcon}
					/>
					:
					<img
						alt={''}
						src={props.icon}
						onClick={props.onClick}
						className={props.classNameIcon}
						style={{
							display: iconOnly ? 'flex' : 'default',
							cursor:  (iconOnly && props.onClick) ? 'pointer' : undefined,
							...(!props.iconBorder && {...style}),
							...styleImg
						}}
					/>
				}
				{(props.popup && hover) &&
					<div
						ref={popupEl}
						className={'iconPopup'}
						style={{
							opacity: popupPosition.left !== 0 ? 1 : 0,
							...props.popupStyle,
							...popupPosition
						}}
					>
						<div style={popupBeforePosition} />
						<span className={'text-sm weight-500 gray-700'}>{props.popup}</span>
					</div>
				}
			</div>
		);
	}

	if (!props.iconBorder)
		return renderIcon(true);

	let className = props.className;

	if (!props.style?.backgroundColor)
		className += ` ${props.type}-100-background ${props.type}-50-border`;

	return (
		<div
			style={{
				cursor: props.onClick ? 'pointer' : 'default',
				...style
			}}
			onClick={props.onClick}
			className={`icon ${className}`}
		>
			{renderIcon()}
		</div>
	);
}

export default Icon;